// extracted by mini-css-extract-plugin
export default {"avatar_margin_left":"-8px"};